'use strict';
import NavigatorHelper from "../../siteSearch/utils/NavigatorHelper";
import DataSourceType from "../interface/DataSourceType";
const resolveJPath = (obj, jpath) => {
    if (obj === undefined || obj === null) {
        return undefined;
    }
    const parts = jpath.split('/');
    const part = parts.splice(0, 1)[0];
    let key;
    let index;
    if (part.indexOf('[') === -1) {
        key = part;
    }
    else {
        const currentPart = part.match(/([^\/]+)\[(.*)]/);
        key = currentPart[1];
        index = parseInt(currentPart[2]);
    }
    obj = obj[key];
    if (index !== undefined) {
        obj = obj[index];
    }
    if (parts.length === 0) {
        return obj;
    }
    return resolveJPath(obj, parts.join('/'));
};
const getMatchingConditions = (expectedConditions) => {
    const matchingConditions = {};
    if (expectedConditions.urlRegex !== undefined) {
        const urlMatch = window.location.href.match(new RegExp(expectedConditions.urlRegex));
        if (urlMatch !== null) {
            matchingConditions.urlRegex = urlMatch[0];
        }
    }
    if (expectedConditions.domElement !== undefined) {
        const elements = [].slice.call(document.querySelectorAll(expectedConditions.domElement));
        if (elements.length > 0) {
            matchingConditions.domElement = elements.map((el) => {
                let str = el.tagName;
                el.getAttributeNames().forEach((attrName) => {
                    str += `[${attrName}="${el.getAttribute(attrName)}"]`;
                });
                return str;
            });
        }
    }
    if (expectedConditions.searchParam !== undefined) {
        matchingConditions.searchParam = NavigatorHelper.buildQueryDict()[expectedConditions.searchParam];
    }
    return matchingConditions;
};
export default {
    matchesExpectedConditions(expectedConditions) {
        if (expectedConditions === undefined) {
            return true;
        }
        const urlMatches = expectedConditions.urlRegex === undefined || window.location.href.match(new RegExp(expectedConditions.urlRegex)) !== null;
        if (!urlMatches) {
            return false;
        }
        const domElementMatches = expectedConditions.domElement === undefined || document.querySelector(expectedConditions.domElement) !== null;
        if (!domElementMatches) {
            return false;
        }
        if (expectedConditions.searchParam !== undefined) {
            return NavigatorHelper.buildQueryDict()[expectedConditions.searchParam] !== undefined;
        }
        return true;
    },
    getMatchingConditions,
    conditionsChanged(expectedConditions, lastExpectedConditions, minChanges = 2) {
        if (expectedConditions === undefined || lastExpectedConditions === undefined) {
            return false;
        }
        let changes = 0;
        const currentMatchingConditions = getMatchingConditions(expectedConditions);
        if (expectedConditions.urlRegex !== undefined && currentMatchingConditions.urlRegex !== lastExpectedConditions.urlRegex) {
            changes++;
        }
        if (expectedConditions.domElement !== undefined) {
            const lastElements = lastExpectedConditions.domElement || [];
            const currentElements = currentMatchingConditions.domElement || [];
            if (lastElements.length !== currentElements.length || lastElements.some((el) => currentElements.indexOf(el) === -1)) {
                changes++;
            }
        }
        if (expectedConditions.searchParam !== undefined && currentMatchingConditions.searchParam !== lastExpectedConditions.searchParam) {
            changes++;
        }
        return changes >= minChanges;
    },
    getDataSourceValue(dataSource, wrapper) {
        if (dataSource === undefined) {
            return '';
        }
        if (wrapper === null || wrapper === undefined) {
            // @ts-ignore
            wrapper = document;
        }
        if (dataSource.type === DataSourceType.Static) {
            return dataSource.value;
        }
        if (dataSource.type === DataSourceType.DomElement) {
            const element = wrapper.querySelector(dataSource.selector);
            const source = dataSource.source;
            if (element === null) {
                return '';
            }
            if (source === undefined || source === 'text' || source.replace('@', '').trim().length === 0) {
                return element.innerText;
            }
            if (source.indexOf('@') !== -1) {
                return element.getAttribute(source.replace('@', ''));
            }
            // @ts-ignore
            return element[source];
        }
        if (dataSource.type === DataSourceType.UrlParam) {
            return NavigatorHelper.buildQueryDict()[dataSource.paramName];
        }
        if (dataSource.type === DataSourceType.UrlRegex) {
            const groupPosition = dataSource.groupIndex !== undefined ? dataSource.groupIndex : 0;
            return decodeURIComponent(window.location.href.match(new RegExp(dataSource.regex))[groupPosition + 1]);
        }
        if (dataSource.type === DataSourceType.Getter && dataSource.getter !== undefined) {
            return dataSource.getter(wrapper);
        }
        if (dataSource.type === DataSourceType.DomObject || dataSource.type === DataSourceType.WindowObject) {
            try {
                //  @ts-ignore
                const object = dataSource.type === DataSourceType.DomObject ? JSON.parse(document.querySelector(dataSource.objectSelector).innerText) : window[dataSource.propertyName];
                return resolveJPath(object, dataSource.jpath);
            }
            catch (err) {
                console.error(err);
            }
        }
        return '';
    },
    resolveJPath
};
